import React from 'react'
import isEmpty from 'lodash.isempty'
import isArray from 'lodash.isarray'
import PropTypes from 'prop-types'
import styles from './styles.module.less'
import { safelyParseJSON } from 'src/utils/helpers'

export default class Parser extends React.PureComponent {
  format = (data = []) => {
    let messages = data
    if (!isArray(messages)) {
      messages = safelyParseJSON(data) || []
    }
    if (!isArray(messages)) {
      return
    }
    return messages.map((el, key) => {
      if (typeof el.text !== 'string') {
        return ''
      }

      if (el.type === 'paragraf') {
        if (isEmpty(el.text)) {
          return <br key={key} />
        }
        return (
          <div className={styles.kioskParagraf} key={key}>
            {el.text}
          </div>
        )
      }
      return <div key={key}>{el.text}</div>
    })
  }

  render() {
    return <React.Fragment>{this.format(this.props.data)}</React.Fragment>
  }
}

Parser.propTypes = {
  text: PropTypes.string,
}
